import React, { useState, useRef, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardFooter from "components/Card/CardFooter.js";
import { useAuth } from "../../context/AuthContext";
import AccountApi from "../../api_calls/AccountApi";
import SimpleAlert from "../../components/AtutaAlerts/CustomAlerts";
import CircularProgress from "@material-ui/core/CircularProgress";
import StorageKeys from "../../constants/storageKeys";

import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";

const useStyles = makeStyles(styles);

export default function VerifyEmailPage() {
  const classes = useStyles();
  const [values, setValues] = useState(["", "", "", ""]);
  const inputRefs = useRef([]);
  const { user, storeUserData } = useAuth();
  const [alertMessage, setAlertMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  useEffect(() => {
    inputRefs.current[0]?.focus();
  }, []);

  const handleChange = (index, e) => {
    const value = e.target.value.replace(/\D/g, "");
    if (!value) return;

    const updated = [...values];
    updated[index] = value.slice(0, 1);
    setValues(updated);

    if (index < 3 && value) {
      inputRefs.current[index + 1]?.focus();
    }
  };
  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      const updated = [...values];
      if (values[index]) {
        updated[index] = ""; // Clear current
        setValues(updated);
      } else if (index > 0) {
        inputRefs.current[index - 1]?.focus();
      }
    }
  };
  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text").replace(/\D/g, "");
    const updated = pasteData.split("").slice(0, 4);
    const combined = ["", "", "", ""];
    updated.forEach((char, i) => {
      combined[i] = char;
    });
    setValues(combined);
    if (updated.length < 4) {
      inputRefs.current[updated.length]?.focus();
    } else {
      inputRefs.current[3]?.blur();
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const code = values.join("");
    console.log("Entered code:", code);
    setLoading(true);

    try {
      const storedEmail = localStorage.getItem(StorageKeys.SIGNUP_EMAIL);
      if (!storedEmail) {
        setAlertMessage("Something went wrong. Email not found in storage.");
        setLoading(false);
        return;
      }

      const response = await AccountApi.verifyEmail({
        email: storedEmail,
        verificationCode: code,
      });

      console.log("Verification response:", response?.data);

      if (response?.data.message === "verification_success") {
        // ✅ No need to update auth, they are not logged in yet
        console.log("Redirecting to login page");
        history.push("/auth/login-page");
      } else {
        setAlertMessage("Invalid verification code. Please try again.");
      }
    } catch (error) {
      console.error("Error verifying email:", error);
      setAlertMessage("An error occurred while verifying your email.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={classes.container}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={6} md={6}>
          <form onSubmit={handleSubmit}>
            <Card login>
              <CardHeader
                className={`${classes.cardHeader} ${classes.textCenter}`}
                color="rose"
              >
                <h4 className={classes.cardTitle}>
                  Enter email verification code below
                </h4>
              </CardHeader>
              <CardBody style={{ textAlign: "center" }}>
                <p style={{ fontSize: "14px", marginBottom: "12px" }}>
                  We’ve sent a verification code to your email address.
                  <br />
                  If you don’t see it,{" "}
                  <strong>check your spam or junk folder</strong>.
                </p>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "12px",
                  }}
                >
                  {values.map((value, index) => (
                    <input
                      key={index}
                      ref={(el) => (inputRefs.current[index] = el)}
                      value={value}
                      onChange={(e) => handleChange(index, e)}
                      onKeyDown={(e) => handleKeyDown(index, e)}
                      onPaste={handlePaste}
                      style={{
                        width: "50px",
                        height: "50px",
                        fontSize: "20px",
                        textAlign: "center",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                      }}
                      maxLength={1}
                    />
                  ))}
                </div>
              </CardBody>
              <CardFooter className={classes.justifyContentCenter}>
                <Button color="rose" type="submit" disabled={loading}>
                  {loading ? (
                    <CircularProgress size={24} style={{ color: "#fff" }} />
                  ) : (
                    "Verify"
                  )}
                </Button>
              </CardFooter>
            </Card>
            {alertMessage && (
              <SimpleAlert
                message={alertMessage}
                onClose={() => setAlertMessage("")}
              />
            )}
          </form>
        </GridItem>
      </GridContainer>
    </div>
  );
}
